import * as React from "react";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {IOrderDetail} from "../models/IOrderDetail";
import {graphQLServices} from "../../../services/GraphQLServices";
import {GET_GENERATEPRESIGNEDURL} from "../GraphQLQueries";

function createData(
	name: string,
	value: string | null | undefined,
) {
	if (!value)
		value = "";
	return {name, value};
}

const StyledTableCell = styled(TableCell)(({theme}) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));

export function OrderDocuments(props: { order: IOrderDetail; errorFiles: string[]; externalFiles: string[] }) {
	
	function getFilenameFromPath(filePath: string): string {
		const parts = filePath.split("/");
		return parts[parts.length - 1];
	}
	
	async function openLink(documentUrl: string) {
		if (documentUrl.indexOf("https") > -1) {
			window.open(documentUrl, "_blank");
		} else {
			const response = await graphQLServices.orderClient.query({
				query: GET_GENERATEPRESIGNEDURL,
				variables: {documentUrl}
			});
			const url = response.data.generatePreSignedUrl?.url;
			if (!url)
				throw new Error("Could not generate preassinged url");
			
			window.open(url, "_blank");
		}
	}
	
	const order = props.order;
	const rows = [];
	if (order.policyS3Path) {
		rows.push(createData("Policy", order.policyS3Path));
	}
	
	if (order.orderRequestS3Path) {
		rows.push(createData("Initial request", order.orderRequestS3Path));
	}
	
	for (let i = 0; i < props.errorFiles.length; i++) {
		rows.push(createData(getFilenameFromPath(props.errorFiles[i]), props.errorFiles[i]));
	}
	
	if (order?.package?.documents) {
		for (let i = 0; i < order.package.documents.length; i++) {
			const element = order.package.documents[i];
			let fileName = element.documentUrl;
			if (element.fileName && element.fileName.length > 0) {
				fileName = element.fileName[0];
			}
			if (fileName) {
				if (!rows.find(x => x.name === fileName))
					rows.push(createData(fileName, element.documentUrl));
			}
			
		}
	}
	
	if (props.externalFiles) {
		for (let i = 0; i < props.externalFiles.length; i++) {
			const fileName = props.externalFiles[i];
			if (rows.find(x => x.name === fileName))
				continue;
		
			rows.push(createData(getFilenameFromPath(fileName), fileName));
		}
	}

	
	return (
		<TableContainer component={Paper}>
			<Table sx={{minWidth: 650}} size="small" aria-label="Data">
				<TableBody>
					{rows.map((row) => (
						<StyledTableRow key={row.name + row.value}
						>
							<StyledTableCell component="th" scope="row">
								{row.name}
							</StyledTableCell>
							<StyledTableCell align="right">
								<Button variant="contained" href="#contained-buttons"
									onClick={() => openLink(row.value)}>
									File download
								</Button></StyledTableCell>
						</StyledTableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
	
}
